/* eslint-disable no-unused-vars */
import React from 'react';
import { Menu } from '@sede-enterprise/shell-ds-react-framework';
import { IMenuItem } from '../../Tanso/Types/types';

interface TabMenuProps {
  items: IMenuItem[];
  itemRender: (item: { path: string; children: React.ReactNode }) => React.ReactElement;
  selectedPath?: string;
}

const TabMenu: React.FC<TabMenuProps> = ({ items, itemRender, selectedPath }) => (
  <Menu
    data-testid='menu_items'
    className='tabMenu'
    mode={'horizontal'}
    triggerSubMenuAction='click'
    items={items}
    itemRender={itemRender}
    selectedPath={selectedPath}
  />
);

export default TabMenu;
